import React, { useRef } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import InvestmentOverview from './InvestmentOverview';
import ROICalculator from './ROICalculator';
import RevenueCharts from './RevenueCharts';
import RiskMitigation from './RiskMitigation';
import Operations from './Operations';
import ContactForm from './ContactForm';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

const PitchDeck = () => {
  const contentRef = useRef(null);

  return (
    <div className="relative">
      <Header contentRef={contentRef} />
      <div ref={contentRef}>
        <HeroSection />
        <InvestmentOverview />
        <ROICalculator />
        <RevenueCharts />
        <RiskMitigation />
        <Operations />
        <ContactForm />
        <Footer />
      </div>
      <WhatsAppButton />
    </div>
  );
};

export default PitchDeck;
